module.exports = __webpack_public_path__ + "img/Schedule-active.f62490e2.svg";